<script setup lang="ts">
const props = defineProps<{
    variant: TVariants
}>();
</script>

<template>
    <slot :variantColors="$style[variant]" />
</template>

<style module>
.primary {
    --c-50:  var(--color-primary-50);
    --c-100: var(--color-primary-100);
    --c-200: var(--color-primary-200);
    --c-300: var(--color-primary-300);
    --c-400: var(--color-primary-400);
    --c-500: var(--color-primary-500);
    --c-600: var(--color-primary-600);
    --c-700: var(--color-primary-700);
    --c-800: var(--color-primary-800);
    --c-900: var(--color-primary-900);
    --c-950: var(--color-primary-950);
    --shadow-xs: var(--shadow-primary-xs);
    --shadow-s: var(--shadow-primary-s);
    --shadow-m: var(--shadow-primary-m);
    --shadow-l: var(--shadow-primary-l);
    --shadow-xl: var(--shadow-primary-xl);
}
.secondary {
    --c-50:  var(--color-secondary-50);
    --c-100: var(--color-secondary-100);
    --c-200: var(--color-secondary-200);
    --c-300: var(--color-secondary-300);
    --c-400: var(--color-secondary-400);
    --c-500: var(--color-secondary-500);
    --c-600: var(--color-secondary-600);
    --c-700: var(--color-secondary-700);
    --c-800: var(--color-secondary-800);
    --c-900: var(--color-secondary-900);
    --c-950: var(--color-secondary-950);
    --shadow-xs: var(--shadow-secondary-xs);
    --shadow-s: var(--shadow-secondary-s);
    --shadow-m: var(--shadow-secondary-m);
    --shadow-l: var(--shadow-secondary-l);
    --shadow-xl: var(--shadow-secondary-xl);
}
.info {
    --c-50:  var(--color-info-50);
    --c-100: var(--color-info-100);
    --c-200: var(--color-info-200);
    --c-300: var(--color-info-300);
    --c-400: var(--color-info-400);
    --c-500: var(--color-info-500);
    --c-600: var(--color-info-600);
    --c-700: var(--color-info-700);
    --c-800: var(--color-info-800);
    --c-900: var(--color-info-900);
    --c-950: var(--color-info-950);
    --shadow-xs: var(--shadow-info-xs);
    --shadow-s: var(--shadow-info-s);
    --shadow-m: var(--shadow-info-m);
    --shadow-l: var(--shadow-info-l);
    --shadow-xl: var(--shadow-info-xl);
}
.success { 
    --c-50:  var(--color-success-50);
    --c-100: var(--color-success-100);
    --c-200: var(--color-success-200);
    --c-300: var(--color-success-300);
    --c-400: var(--color-success-400);
    --c-500: var(--color-success-500);
    --c-600: var(--color-success-600);
    --c-700: var(--color-success-700);
    --c-800: var(--color-success-800);
    --c-900: var(--color-success-900);
    --c-950: var(--color-success-950);
    --shadow-xs: var(--shadow-success-xs);
    --shadow-s: var(--shadow-success-s);
    --shadow-m: var(--shadow-success-m);
    --shadow-l: var(--shadow-success-l);
    --shadow-xl: var(--shadow-success-xl);
}
.warning { 
    --c-50:  var(--color-warning-50);
    --c-100: var(--color-warning-100);
    --c-200: var(--color-warning-200);
    --c-300: var(--color-warning-300);
    --c-400: var(--color-warning-400);
    --c-500: var(--color-warning-500);
    --c-600: var(--color-warning-700);
    --c-700: var(--color-warning-600);
    --c-800: var(--color-warning-800);
    --c-900: var(--color-warning-900);
    --c-950: var(--color-warning-950);
    --shadow-xs: var(--shadow-warning-xs);
    --shadow-s: var(--shadow-warning-s);
    --shadow-m: var(--shadow-warning-m);
    --shadow-l: var(--shadow-warning-l);
    --shadow-xl: var(--shadow-warning-xl);
}
.error {
    --c-50:  var(--color-error-50);
    --c-100: var(--color-error-100);
    --c-200: var(--color-error-200);
    --c-300: var(--color-error-300);
    --c-400: var(--color-error-400);
    --c-500: var(--color-error-500);
    --c-600: var(--color-error-700);
    --c-700: var(--color-error-700);
    --c-800: var(--color-error-800);
    --c-900: var(--color-error-900);
    --c-950: var(--color-error-950);
    --shadow-xs: var(--shadow-error-xs);
    --shadow-s: var(--shadow-error-s);
    --shadow-m: var(--shadow-error-m);
    --shadow-l: var(--shadow-error-l);
    --shadow-xl: var(--shadow-error-xl);
}
.gray {
    --c-50:  var(--color-gray-50);
    --c-100: var(--color-gray-100);
    --c-200: var(--color-gray-200);
    --c-300: var(--color-gray-300);
    --c-400: var(--color-gray-400);
    --c-500: var(--color-gray-500);
    --c-600: var(--color-gray-600);
    --c-700: var(--color-gray-700);
    --c-800: var(--color-gray-800);
    --c-900: var(--color-gray-900);
    --c-950: var(--color-gray-950);
    --shadow-xs: var(--shadow-gray-xs);
    --shadow-s: var(--shadow-gray-s);
    --shadow-m: var(--shadow-gray-m);
    --shadow-l: var(--shadow-gray-l);
    --shadow-xl: var(--shadow-gray-xl);
}
.purple {
    --c-50:  var(--color-purple-50);
    --c-100: var(--color-purple-100);
    --c-200: var(--color-purple-200);
    --c-300: var(--color-purple-300);
    --c-400: var(--color-purple-400);
    --c-500: var(--color-purple-500);
    --c-600: var(--color-purple-600);
    --c-700: var(--color-purple-700);
    --c-800: var(--color-purple-800);
    --c-900: var(--color-purple-900);
    --c-950: var(--color-purple-950);
    --shadow-xs: var(--shadow-purple-xs);
    --shadow-s: var(--shadow-purple-s);
    --shadow-m: var(--shadow-purple-m);
    --shadow-l: var(--shadow-purple-l);
    --shadow-xl: var(--shadow-purple-xl);
}
.amber { 
    --c-50:  var(--color-amber-50);
    --c-100: var(--color-amber-100);
    --c-200: var(--color-amber-200);
    --c-300: var(--color-amber-300);
    --c-400: var(--color-amber-400);
    --c-500: var(--color-amber-500);
    --c-600: var(--color-amber-600);
    --c-700: var(--color-amber-700);
    --c-800: var(--color-amber-800);
    --c-900: var(--color-amber-900);
    --c-950: var(--color-amber-950);
    --shadow-xs: var(--shadow-amber-xs);
    --shadow-s: var(--shadow-amber-s);
    --shadow-m: var(--shadow-amber-m);
    --shadow-l: var(--shadow-amber-l);
    --shadow-xl: var(--shadow-amber-xl);
}
.lime { 
    --c-50:  var(--color-lime-50);
    --c-100: var(--color-lime-100);
    --c-200: var(--color-lime-200);
    --c-300: var(--color-lime-300);
    --c-400: var(--color-lime-400);
    --c-500: var(--color-lime-500);
    --c-600: var(--color-lime-600);
    --c-700: var(--color-lime-700);
    --c-800: var(--color-lime-800);
    --c-900: var(--color-lime-900);
    --c-950: var(--color-lime-950);
    --shadow-xs: var(--shadow-lime-xs);
    --shadow-s: var(--shadow-lime-s);
    --shadow-m: var(--shadow-lime-m);
    --shadow-l: var(--shadow-lime-l);
    --shadow-xl: var(--shadow-lime-xl);
}
.teal {
    --c-50:  var(--color-teal-50);
    --c-100: var(--color-teal-100);
    --c-200: var(--color-teal-200);
    --c-300: var(--color-teal-300);
    --c-400: var(--color-teal-400);
    --c-500: var(--color-teal-500);
    --c-600: var(--color-teal-600);
    --c-700: var(--color-teal-700);
    --c-800: var(--color-teal-800);
    --c-900: var(--color-teal-900);
    --c-950: var(--color-teal-950);
    --shadow-xs: var(--shadow-teal-xs);
    --shadow-s: var(--shadow-teal-s);
    --shadow-m: var(--shadow-teal-m);
    --shadow-l: var(--shadow-teal-l);
    --shadow-xl: var(--shadow-teal-xl);
}
.pink {
    --c-50:  var(--color-pink-50);
    --c-100: var(--color-pink-100);
    --c-200: var(--color-pink-200);
    --c-300: var(--color-pink-300);
    --c-400: var(--color-pink-400);
    --c-500: var(--color-pink-500);
    --c-600: var(--color-pink-600);
    --c-700: var(--color-pink-700);
    --c-800: var(--color-pink-800);
    --c-900: var(--color-pink-900);
    --c-950: var(--color-pink-950);
    --shadow-xs: var(--shadow-pink-xs);
    --shadow-s: var(--shadow-pink-s);
    --shadow-m: var(--shadow-pink-m);
    --shadow-l: var(--shadow-pink-l);
    --shadow-xl: var(--shadow-pink-xl);
}
.white {
    --c-50:  var(--color-primary-600);
    --c-100: var(--color-primary-800);
    --c-200: var(--color-primary-900);
    --c-300: var(--color-primary-500);
    --c-400: var(--color-primary-50);
    --c-500: var(--color-primary-50);
    --c-600: white;
    --c-700: white;
    --c-800: var(--color-primary-800);
    --c-900: var(--color-primary-900);
    --c-950: var(--color-primary-950);
    --shadow-xs: var(--shadow-gray-xs);
    --shadow-s: var(--shadow-gray-s);
    --shadow-m: var(--shadow-gray-m);
    --shadow-l: var(--shadow-gray-l);
    --shadow-xl: var(--shadow-gray-xl);
}
</style>